module.exports = __webpack_public_path__ + "img/ico_locator_gris.65eb405a.svg";